import { useEffect, useRef } from 'react';
import { chime } from './inboxAlarm';

/**
 * Lead inbox 새 인계 토스트 — Ops 콘솔 어느 화면에서든 오른쪽 아래(ToastStack)에 뜬다.
 * 확인(Open review · 닫기 · 상세 열기)할 때까지 남고, 새 토스트가 뜰 때 알림음이 한 번 울린다.
 * 확인한 건은 브라우저에 남겨 새로고침해도 다시 뜨지 않는다. 다시 제출(v2…)되면 새 건으로 본다.
 */

export const ACKED_STORE = 'td-inbox-acked';
const MAX_SHOWN = 3;

export const inboxKey = (item) => `${item.id}:v${item.version}`;

export const loadAcked = () => {
  try {
    return new Set(JSON.parse(window.localStorage.getItem(ACKED_STORE) ?? '[]'));
  } catch {
    return new Set();
  }
};

export const saveAcked = (set) => {
  try {
    // 오래된 것부터 버려 크기를 묶어 둔다
    window.localStorage.setItem(ACKED_STORE, JSON.stringify([...set].slice(-500)));
  } catch {
    // 저장이 막혀도 이번 화면에서는 확인한 것으로 둔다
  }
};

/** 새 건이 뜰 때 알림음 한 번 — 처음 본 키만 */
export const useInboxChime = (items) => {
  const seen = useRef(new Set());
  const keys = items.map(inboxKey).join(',');
  useEffect(() => {
    const fresh = items.map(inboxKey).filter((k) => !seen.current.has(k));
    fresh.forEach((k) => seen.current.add(k));
    if (fresh.length) chime();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keys]);
};

/**
 * 디자인 시스템 Toast(ToastStack) 항목 — 닫을 때까지 남는다(mostImportant). 4건부터는 마지막 토스트에 남은 수
 */
export const inboxToastItems = (items, onOpen) =>
  items.slice(0, MAX_SHOWN).map((i, idx) => ({
    id: `inbox:${inboxKey(i)}`,
    type: 'info',
    state: 'white',
    hierarchy: 'mostImportant',
    title: 'New handoff to review',
    message: `${i.teamName} · ${i.code ? `${i.code} ` : ''}${i.title} · v${i.version}${
      idx === MAX_SHOWN - 1 && items.length > MAX_SHOWN
        ? `\n+${items.length - MAX_SHOWN} more to review`
        : ''
    }`,
    buttonLabel: 'Open review',
    onButtonClick: () => onOpen(i),
  }));
